import { CustomerPageStep } from 'src/pages/CustomersPage/CustomersPage.context.types';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';
import { ProductSpecificationFieldGroup } from 'src/types/reference/ProductSpecificationFieldGroup';

export function isCustomerStepSubmitted(
  step: CustomerPageStep,
  customerLeadProduct: ICustomerLeadProduct | null
): boolean {
  if (customerLeadProduct) {
    if (step === CustomerPageStep.Quantities) {
      return (
        customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.InitialRequest) &&
        customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.Frequency)
      );
    }

    if (step === CustomerPageStep.ProductSpecifications) {
      return customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.ProductDetails);
    }

    if (step === CustomerPageStep.AdditionalInformation) {
      return customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.PurchaseItems);
    }

    if (step === CustomerPageStep.ShippingAndContacts) {
      return (
        customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.Contacts) &&
        customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.ShippingAddress) &&
        customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.BillingAddress) &&
        customerLeadProduct.submittedFieldGroups.includes(ProductSpecificationFieldGroup.SalesTaxInfo)
      );
    }
  }

  return false;
}
